import createReducer from 'utils/createReducer';
import get from 'lodash/get';

import {
    SET_FORM_LIBRARY_LIST,
    SET_FORM_LIBRARY_PAGE,
    SET_PAGE_LIMIT_REACHED,
    SET_FORM_LIBRARY_STATUS,
    ADD_FORM_LIBRARY_LIST,
    SET_FORM_LIBRARY_SEARCH_TERM,
    SET_EVENT_THEME_COUNT,
    SET_FORM_LIBRARY_ERROR,
    SET_SCALED_FORM_MODAL_STATUS_OPEN,
} from '../constants/actionTypes';

export const SEARCHING = 'searching';
export const APPLYING = 'applying';
export const FETCHING = 'fetching';
export const SAVING = 'saving';
export const SAVED = 'saved';
export const DEFAULT = 'default';

const initialState = {
    pageLimitReached: false,
    formList: [],
    page: 0,
    status: DEFAULT,
    searchTerm: '',
    eventCount: 0,
    themeCount: 0,
    inlineError: false,
    scaledFormModalStatus: false,
};

const handlers = {
    [SET_FORM_LIBRARY_LIST]: (state, { payload }) => ({
        ...state,
        formList: payload,
    }),
    [ADD_FORM_LIBRARY_LIST]: (state, { payload }) => ({
        ...state,
        formList: [...state.formList, ...payload],
    }),
    [SET_FORM_LIBRARY_STATUS]: (state, { payload }) => ({
        ...state,
        status: payload,
    }),
    [SET_FORM_LIBRARY_PAGE]: (state, { payload }) => ({
        ...state,
        page: payload,
    }),
    [SET_PAGE_LIMIT_REACHED]: (state, { payload }) => ({
        ...state,
        pageLimitReached: payload,
    }),
    [SET_FORM_LIBRARY_SEARCH_TERM]: (state, { payload }) => ({
        ...state,
        searchTerm: payload,
    }),
    [SET_EVENT_THEME_COUNT]: (state, { payload }) => ({
        ...state,
        eventCount: get(payload, 'eventCount', 0),
        themeCount: get(payload, 'themeCount', 0),
    }),
    [SET_FORM_LIBRARY_ERROR]: (state, { payload }) => ({
        ...state,
        inlineError: payload,
    }),
    [SET_SCALED_FORM_MODAL_STATUS_OPEN]: (state, { payload }) => ({
        ...state,
        scaledFormModalStatus: payload,
    }),
};

export default createReducer(initialState, handlers);
